<template>
  <v-overlay
    absolute
    z-index=0
    class="fullcontent">
    <v-img
      src="@/assets/bg.jpg"
      height="100vh"
      position="center center"
      gradient="to top right, rgba(0, 9, 58, 0.33), rgba(18, 24, 62, 0.7)"
    ></v-img>
  </v-overlay>
</template>

<script>
export default {

}
</script>

<style>

</style>